import React from "react";
import * as styles from "./ContactsSection.module.scss";
import { officesData, contactEmail } from "@shared/arrays/about-company";

export const ContactsSection: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.tag}>Get in touch</span>
          <h2 className={styles.title}>Our offices</h2>
        </div>

        <div className={styles.officesGrid}>
          {officesData.map((office) => (
            <div key={office.city} className={styles.officeCard}>
              <iframe
                className={styles.mapFrame}
                title={`${office.city} office map`}
                src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyArvxLKeIzC3VmKWtiZ2M1-3KNUsh-RNu4&q=${office.mapQuery}`}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
              <div className={styles.officeInfo}>
                <p className={styles.officeCity}>{office.city}</p>
                <p className={styles.officeCountry}>{office.country}</p>
                <p className={styles.officeAddress}>{office.address}</p>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.contactRow}>
          <span>Email us:</span>
          <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
        </div>
      </div>
    </section>
  );
};

export default ContactsSection;
